import React, {useState} from "react";
import {IconButton, Dialog, DialogContent, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import useTheme from "@mui/material/styles/useTheme";
import PropTypes from "prop-types";
import ProjectService from "../api/project";

const PdfJsIframeViewer = ({operation_id, project_profile_id, task_id, file_type, file_name, apiKey}) => {
    const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const theme = useTheme();

    const handleViewPdf = async () => {
        setErrorMsg("");
        setLoading(true);
        setPdfBlobUrl(null);
        setModalOpen(true);
        try {
            const res = await ProjectService.GetProjectFile({
                operation_id,
                project_profile_id,
                task_id,
                file_type: file_type || "pdf",
                file_name: file_name || "commissioning_sign_off",
                apiKey
            });
            console.log("PDF fetch result:", res);

            if (res.success && res.count > 0) {
                const base64 = res.project_task_private_file[0].base64_content.replace("dataapplication/pdfbase64", "data:application/pdf;base64,");
                const base64Data = base64.split(",")?.[1] || base64;
                const byteChars = atob(base64Data);
                const byteArray = new Uint8Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) {
                    byteArray[i] = byteChars.charCodeAt(i);
                }
                const blob = new Blob([byteArray], {type: "application/pdf"});
                const objectUrl = URL.createObjectURL(blob);
                setPdfBlobUrl(objectUrl);
            } else {
                setErrorMsg("No Commissioning Sign Off PDF found for this machine. Please ask an administrator to upload one.");
            }
        } catch (err) {
            setErrorMsg("Failed to fetch PDF.");
            console.error("Failed to fetch PDF", err);
        }
        setLoading(false);
    };

    return (
        <div>
            <IconButton
                onClick={handleViewPdf}
                sx={{
                    "backgroundColor": theme.palette.custom.buttonColor,
                    "borderRadius": "4px",
                    "border": `1px solid ${theme.palette.custom.borderColor}`,
                    "marginLeft": "10px",
                    "width": "fit-content",
                    "height": "36px",
                    "padding": "5px 10px",
                    "display": "flex",
                    "alignItems": "center",
                    "cursor": "pointer",
                    "&:hover": {
                        backgroundColor: theme.palette.custom.buttonHoverColor,
                        color: theme.palette.custom.buttonHoverTextColor,
                        boxShadow: "none"
                    }
                }}>
                <PictureAsPdfIcon />
            </IconButton>

            <Dialog
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                fullScreen
                PaperProps={{
                    style: {position: "relative"}
                }}
                BackdropProps={{
                    style: {touchAction: "none"}
                }}>
                <IconButton
                    onClick={() => setModalOpen(false)}
                    sx={{
                        "position": "absolute",
                        "top": 16,
                        "right": 40,
                        "zIndex": 1000,
                        "backgroundColor": theme.palette.custom.buttonColor,
                        "borderRadius": "4px",
                        "border": `1px solid ${theme.palette.custom.borderColor}`,
                        "width": "fit-content",
                        "height": "36px",
                        "padding": "5px 10px",
                        "display": "flex",
                        "alignItems": "center",
                        "cursor": "pointer",
                        "&:hover": {
                            backgroundColor: theme.palette.custom.buttonHoverColor,
                            color: theme.palette.custom.buttonHoverTextColor,
                            boxShadow: "none"
                        }
                    }}>
                    <CloseIcon />
                </IconButton>

                <DialogContent style={{padding: 0}} onContextMenu={(e) => e.preventDefault()}>
                    {loading && (
                        <Typography sx={{p: "10px"}} variant="h5">
                            Loading...
                        </Typography>
                    )}
                    {errorMsg && (
                        <Typography sx={{p: "10px"}} variant="h5">
                            {errorMsg}
                        </Typography>
                    )}
                    {!loading && !errorMsg && pdfBlobUrl && <iframe title="PDF.js Viewer" src={`/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfBlobUrl)}`} width="100%" height="100%" style={{border: "none"}} sandbox="allow-same-origin allow-scripts" onContextMenu={(e) => e.preventDefault()} />}
                </DialogContent>
            </Dialog>
        </div>
    );
};

PdfJsIframeViewer.propTypes = {
    operation_id: PropTypes.string.isRequired,
    project_profile_id: PropTypes.string.isRequired,
    task_id: PropTypes.string.isRequired,
    file_type: PropTypes.string,
    file_name: PropTypes.string,
    apiKey: PropTypes.string.isRequired
};

export default PdfJsIframeViewer;
